import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import iconHome from '../../assets/images/icons/Cinzentos/Home.svg';
import { config } from '../../common';
import * as ValueRepair from '..';
import React from 'react';

const BaseLayout: React.FC<{}> = () => {
    const { t } = useTranslation();
    return (
        <div className={classNames(['grid-container', 'padding-bottom-4', 'value-service'])}>
            <div className={classNames(['grid-x', 'grid-margin-x'])}>
                <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                    <h1 className={'header'}>{t('cards:baseHeaderRepair')}</h1>
                </div>
                <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                    <h2>{t('cards:footer.topText2Repair')}</h2>
                </div>
                <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                    <ul className={'tabs'} >
                        <li className={classNames(['tabs-title', 'float-right'])}>
                            <a className={'header-btn'} href={config.BaseURL}>
                                <img src={iconHome} alt={t(`common:home`)} />
                                {t(`common:home`)}
                            </a>
                        </li>
                    </ul>
                    <ValueRepair.PacksLayout />
                </div>
            </div>
        </div>
    );
};

export default BaseLayout;
